import Vue from "vue";

export const store = Vue.observable({
  user: null
})